import React, { useEffect, useState } from "react";
import { Bars3BottomLeftIcon } from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import withAuth from "../hoc/withAuth";
import { setShowSideBar } from "../reducers/common.reducer";
import { Link, useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import SideBar from "./CusSidebar";
import logo from "../assets/images/Equity Pal.png"
import { selectUserData } from '../reducers/user.reducer';

const Layout = ( props ) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const title = {
    "/dashboard": "Dashboard",
    "/exchange-rate": "Exchange Rate",
    "/transfer-type": "Transfer Type",
    "/history": "History",
    "/agent": "Agent",
    "/job": "Job",
    "/user": "User",
  };

  const [user, setUser] = useState({ 'userId': '', 'username': '' });

  const userData= useSelector(selectUserData);

  useEffect(() => {
      setUser({
          userId: userData?.userInfo?.userId,
          username: userData?.userInfo?.username
      });
  }, [userData]);

  return (
    <>
      <SideBar />
      <div className="flex flex-auto h-screen w-full flex-row overflow-hidden">
        <div className="flex flex-col flex-1 overflow-y-auto">
          <div
            className={`${
              location.pathname === "/login" ? "hidden" : "flex"
            } items-center justify-between h-16 bg-white border-b border-gray-200`}
          >
            <div className="flex items-center ml-2">
              <button
                className="ml-4"
                onClick={() => dispatch(setShowSideBar())}
              >
                <Bars3BottomLeftIcon
                  className="h-6 w-6 text-gray-600"
                  aria-hidden="true"
                />
              </button>
              <h1 className="font-bold text-primary text-sm ml-4 hidden md:block">
                Adding one person's idea to another's thought will create the most successful situation
              </h1>
              <img src={logo} className="ml-4 block md:hidden w-20 h-4" alt="" />
            </div>
            <div className="flex items-center space-x-4 mr-4">
              {/* <Link
                to="/notification"
                className="text-gray-600 hover:text-gray-800"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M6.429 2.413a.75.75 0 0 0-1.13-.986l-1.292 1.48a4.75 4.75 0 0 0-1.17 3.024L2.78 8.65a.75.75 0 1 0 1.5.031l.056-2.718a3.25 3.25 0 0 1 .801-2.069z"
                  />
                  <path
                    fill="currentColor"
                    fillRule="evenodd"
                    d="M6.237 7.7a4.214 4.214 0 0 1 4.206-3.95H11V3a1 1 0 1 1 2 0v.75h.557a4.214 4.214 0 0 1 4.206 3.95l.221 3.534a7.376 7.376 0 0 0 1.308 3.754a1.617 1.617 0 0 1-1.135 2.529l-3.407.408V19a2.75 2.75 0 1 1-5.5 0v-1.075l-3.407-.409a1.617 1.617 0 0 1-1.135-2.528a7.377 7.377 0 0 0 1.308-3.754zm4.206-2.45a2.714 2.714 0 0 0-2.709 2.544l-.22 3.534a8.877 8.877 0 0 1-1.574 4.516a.117.117 0 0 0 .082.183l3.737.449c1.489.178 2.993.178 4.482 0l3.737-.449a.117.117 0 0 0 .082-.183a8.876 8.876 0 0 1-1.573-4.516l-.221-3.534a2.714 2.714 0 0 0-2.709-2.544zm1.557 15c-.69 0-1.25-.56-1.25-1.25v-.75h2.5V19c0 .69-.56 1.25-1.25 1.25"
                    clipRule="evenodd"
                  />
                  <path
                    fill="currentColor"
                    d="M17.643 1.355a.75.75 0 0 0-.072 1.058l1.292 1.48a3.25 3.25 0 0 1 .8 2.07l.057 2.717a.75.75 0 0 0 1.5-.031l-.057-2.718a4.75 4.75 0 0 0-1.17-3.024l-1.292-1.48a.75.75 0 0 0-1.058-.072"
                  />
                </svg>
              </Link> */}
              {/* <!-- parametre --> */}
              {/* <Link
                to={"/settings"}
                className="text-gray-600 hover:text-gray-800 "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M19.9 12.66a1 1 0 0 1 0-1.32l1.28-1.44a1 1 0 0 0 .12-1.17l-2-3.46a1 1 0 0 0-1.07-.48l-1.88.38a1 1 0 0 1-1.15-.66l-.61-1.83a1 1 0 0 0-.95-.68h-4a1 1 0 0 0-1 .68l-.56 1.83a1 1 0 0 1-1.15.66L5 4.79a1 1 0 0 0-1 .48L2 8.73a1 1 0 0 0 .1 1.17l1.27 1.44a1 1 0 0 1 0 1.32L2.1 14.1a1 1 0 0 0-.1 1.17l2 3.46a1 1 0 0 0 1.07.48l1.88-.38a1 1 0 0 1 1.15.66l.61 1.83a1 1 0 0 0 1 .68h4a1 1 0 0 0 .95-.68l.61-1.83a1 1 0 0 1 1.15-.66l1.88.38a1 1 0 0 0 1.07-.48l2-3.46a1 1 0 0 0-.12-1.17ZM18.41 14l.8.9l-1.28 2.22l-1.18-.24a3 3 0 0 0-3.45 2L12.92 20h-2.56L10 18.86a3 3 0 0 0-3.45-2l-1.18.24l-1.3-2.21l.8-.9a3 3 0 0 0 0-4l-.8-.9l1.28-2.2l1.18.24a3 3 0 0 0 3.45-2L10.36 4h2.56l.38 1.14a3 3 0 0 0 3.45 2l1.18-.24l1.28 2.22l-.8.9a3 3 0 0 0 0 3.98m-6.77-6a4 4 0 1 0 4 4a4 4 0 0 0-4-4m0 6a2 2 0 1 1 2-2a2 2 0 0 1-2 2"
                  />
                </svg>
              </Link> */}
              {/* <!-- logout --> */}
              <Link
                to={"/login"}
                className="flex items-center text-gray-600 hover:text-gray-800 "
              >
                <h1 className="px-2 font-semibold">{user?.username}</h1>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M5 11h8v2H5v3l-5-4l5-4zm-1 7h2.708a8 8 0 1 0 0-12H4a9.985 9.985 0 0 1 8-4c5.523 0 10 4.477 10 10s-4.477 10-10 10a9.985 9.985 0 0 1-8-4"
                  />
                </svg>
                <span className="font-bold hidden md:block">Logout</span>
              </Link>
            </div>
          </div>

          <div className="w-full h-full bg-bgColor">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default withAuth(Layout);
